export const OFFER_UPDATED = `offers/OFFER_UPDATED`
export const OFFER_SELECTED = `offers/OFFER_SELECTED`
export const BOOKING_SELECTED = `offers/BOOKING_SELECTED`
export const OFFER_STATUS_UPDATED = `offers/OFFER_STATUS_UPDATED`
export const MARK_OFFER_AS_SEEN = `offers/MARK_OFFER_AS_SEEN`
export const ACCEPT_EXTENDED_DURATION = `offers/ACCEPT_EXTENDED_DURATION`
export const DECLINE_EXTENDED_DURATION = `offers/DECLINE_EXTENDED_DURATION`
